import * as React from 'react'
import {renderPopular} from '../../../../utils/tools'
import * as Styles from './HomeLimitBar.style'
import {classes} from 'typestyle'
import HomeType from '../../types/HomeType'

interface HomeLimitBarProp {
    data: {
        name: string,
        start_time?: number,
        end_time?: number,
        contents: HomeType.Content[]
    }
}

export default class HomeLimitBar extends React.Component <HomeLimitBarProp> {
    public timeout: number | any
    public timer: number | any
    public limitHhRef: React.RefObject<HTMLSpanElement>
    public limitMmRef: React.RefObject<HTMLSpanElement>
    public limitSsRef: React.RefObject<HTMLSpanElement>
    public limitMsRef: React.RefObject<HTMLSpanElement>
    constructor(props: HomeLimitBarProp) {
        super(props)
        this.limitHhRef = React.createRef()
        this.limitMmRef = React.createRef()
        this.limitSsRef = React.createRef()
        this.limitMsRef = React.createRef()
        this.timeout = null
        this.timer = null
        this.state = {
            show: false
        }
    }

    public componentDidMount() {
        const data = this.props.data
        const startTime = data.start_time
        const endTime = data.end_time ? data.end_time : 0
        const currentTime = new Date().getTime() / 1000
        if (!startTime || data.contents.length === 0) {
            return
        }

        if (currentTime > startTime) {
            this.onTime(endTime)
        } else {
            this.timeout = setTimeout(() => {
                this.onTime(endTime)
            }, (startTime - currentTime) * 1000)
        }
    }

    public onTime(endTime: number) {
        const getDuration = () => (endTime - new Date().getTime() / 1000)
        const getMs = () => 9 - ~~(new Date().getTime() / 1000).toString().split('.')[1] / 100
        this.setState({show: true})

        const That = this
        this.timer = requestAnimationFrame(function fn() {
            const duration = getDuration()
            const ms = getMs().toString()
            if (duration < 0) {
                That.setState({show: false})
                cancelAnimationFrame(That.timer)
            } else {
                if (That.limitMsRef.current != null) {
                    That.limitMsRef.current.innerHTML = ms[0]
                }
                let tmp = duration.toString()
                const ss = (parseFloat(tmp) % 60).toString()
                if (That.limitSsRef.current != null) {
                    That.limitSsRef.current.innerHTML = ss.substring(0, 2)
                }

                tmp = ((parseFloat(tmp) - parseFloat(ss)) / 60).toString()
                const mm = (parseFloat(tmp) % 60).toString()
                if (That.limitMmRef.current != null) {
                    That.limitMmRef.current.innerHTML = mm
                }

                tmp = ((parseFloat(tmp) - parseFloat(mm)) / 60).toString()
                const dd = ((parseFloat(tmp) - parseFloat(tmp) % 24) / 24).toString()
                if (That.limitHhRef.current != null) {
                    That.limitHhRef.current.innerHTML = (parseFloat(tmp) % 24 + parseFloat(dd) * 24).toString()
                }

                That.timer = requestAnimationFrame(fn)
            }
        })
    }
    public gotoUrl(url: string) {
        location.assign(url)
    }

    public componentWillUnmount() {
        // tslint:disable-next-line
        this.timeout && window.clearTimeout(this.timeout)
        // tslint:disable-next-line
        this.timer && cancelAnimationFrame(this.timer)
    }
    public render() {
        return (
         <div className={Styles.HomeLimitBar}>
            <div className={Styles.LimitBarTitle}>
                <p className={classes(Styles.LimitBarTitleMain, Styles.WkClampLine)}>{this.props.data.name}</p>
                <span style={{float: 'left', marginLeft: 10}}>
                    <span className={Styles.LimitBarTimeNum} ref={this.limitHhRef}>0</span>
                    <span className={Styles.LimitBarTimePoint}>:</span>
                    <span className={Styles.LimitBarTimeNum} ref={this.limitMmRef}>0</span>
                    <span className={Styles.LimitBarTimePoint}>:</span>
                    <span className={Styles.LimitBarTimeNum} ref={this.limitSsRef}>0</span>
                    <span className={Styles.LimitBarTimePoint}>.</span>
                    <span className={Styles.LimitBarTimeNum} ref={this.limitMsRef}>0</span>
                </span>
            </div>

            <div className={Styles.LimitBarContent}>
                {this.props.data.contents.map((item: any, index: number) =>
                    <div className={Styles.LimitBarItem} key={index} onClick={this.gotoUrl.bind(this, item.obj_url)}>
                        <div
                            className={Styles.LimitBarItemImage}
                            style={{backgroundImage: `url(${item.cover_url})`}}
                        >
                            <div className={Styles.LimitBarItemName}>
                                    <p>{item.title}</p>
                            </div>
                        </div>
                        <div className={Styles.LimitBarItemBottom}>
                            <span className={Styles.LimitBarItemFu}>￥</span>
                            <span className={Styles.LimitBarItemMoney}>{item.price.toString().split('.').length > 0 && `${item.price.toString().split('.')[0]}`}</span>
                            <span className={Styles.LimitBarItemPoint} style={{marginLeft: /WindowsWechat/.test(navigator.userAgent) ? '3px' : '0'}}>
                                {item.price.toString().split('.').length > 1 && `.${item.price.toString().split('.')[1]}`}
                            </span>
                            <div className={Styles.LimitBarItemBd}>
                                <span className={Styles.LimitBarItemOrigin}>原价：{item.real_money}</span>
                                {/* <span className={Styles.LimitBarItemPopular}>{renderPopular(item.popular)}人抢</span> */}
                                <span className={Styles.LimitBarItemPopular}>尝鲜价</span>
                            </div>
                            <img
                                className={Styles.LimitBarItemIcon}
                                src="https://static-1253442168.image.myqcloud.com/picture/7833117_8e4563360095bbea0f235f13907bbbe9.jpg-picmsg420"
                            />
                        </div>
                    </div>
                )}
                <div className="clearBoth" style={{minWidth: 5, width: 5}}/>
            </div>
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeLimitBar/HomeLimitBar.tsx